var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2542",
    "data-name": "Group 2542",
    transform: "translate(140.55 -144.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M-121.5,419.053a.731.731,0,0,1-.77.456c-1.057-.014-2.114-.005-3.187-.005a2.867,2.867,0,0,1-1.355,1.854,2.634,2.634,0,0,1-1.661.342,2.8,2.8,0,0,1-2.4-2.2h-8.965a.608.608,0,0,1-.662-.645.587.587,0,0,1,.5-.564,2.353,2.353,0,0,1,.278-.01q4.312,0,8.624,0c.174,0,.237-.05.285-.222a2.778,2.778,0,0,1,2.654-2,2.8,2.8,0,0,1,2.641,2.029l.055.194h.372c.927,0,1.855.012,2.782-.006a.765.765,0,0,1,.8.434Zm-6.67,1.444a1.6,1.6,0,0,0,1.582-1.61,1.6,1.6,0,0,0-1.572-1.6,1.6,1.6,0,0,0-1.579,1.613A1.592,1.592,0,0,0-128.174,420.5Z",
    transform: "translate(-0.046 -258.456)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M-121.544,147.257a.766.766,0,0,1-.8.434c-1.044-.017-2.089-.006-3.14-.006-.071.192-.129.384-.21.564a2.76,2.76,0,0,1-2.687,1.653,2.778,2.778,0,0,1-2.476-2.039c-.044-.157-.119-.182-.259-.182q-4.331.006-8.663,0a1.2,1.2,0,0,1-.365-.038.6.6,0,0,1-.392-.654.61.61,0,0,1,.553-.524c.061-.005.124,0,.185,0h8.887a2.914,2.914,0,0,1,.673-1.3,2.768,2.768,0,0,1,1.491-.86.968.968,0,0,0,.118-.042h.816a.464.464,0,0,0,.085.033,2.7,2.7,0,0,1,1.534.848,2.916,2.916,0,0,1,.692,1.323h.21c.994,0,1.987.01,2.981-.005a.728.728,0,0,1,.769.456Zm-6.659-1.786a1.592,1.592,0,0,0-1.58,1.61,1.6,1.6,0,0,0,1.568,1.605,1.606,1.606,0,0,0,1.583-1.613A1.6,1.6,0,0,0-128.2,145.472Z",
    transform: "translate(-0.006 0)",
    fill: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M-121.55,283.037a.7.7,0,0,1-.746.46c-2.881-.01-5.763-.005-8.644-.005h-.22a2.764,2.764,0,0,1-2.791,2.214,2.764,2.764,0,0,1-2.644-2.214h-.217c-1.051,0-2.1,0-3.154,0a.6.6,0,0,1-.579-.512.606.606,0,0,1,.418-.674.838.838,0,0,1,.238-.025q1.54,0,3.079,0h.218a2.849,2.849,0,0,1,1.273-1.808,2.63,2.63,0,0,1,1.5-.413,2.808,2.808,0,0,1,2.649,2.222h.213c2.888,0,5.775,0,8.663-.005a.706.706,0,0,1,.746.46Zm-12.332,1.451a1.586,1.586,0,0,0,1.572-1.614,1.584,1.584,0,0,0-1.576-1.591,1.59,1.59,0,0,0-1.575,1.594A1.592,1.592,0,0,0-133.881,284.487Z",
    transform: "translate(0 -129.129)",
    fill: "#5a5a5a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.df522b5de262feef64019b0eda5dcb23.svg";
export { ForwardRef as ReactComponent };